import type { IButtonIconProps } from './buttonIcon.type';

export const getLoaderSize = (size: IButtonIconProps['size']): string => {
  switch (size) {
    case 'large':
      return '1.5rem';

    case 'medium':
    case 'small':
    default:
      return '1rem';
  }
};
